module.exports = __webpack_public_path__ + "img/teacherImg.d3fc241c.png";